class LandingpageProduct extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const buttons = Array.from(this.querySelectorAll("button[data-metal-color]"));
    for (const button of buttons) {
      const metalColor = button.dataset.metalColor;
      button.addEventListener("click", () =>  { this.dataset.metalColor = metalColor; });
    }
    const swiper = this.querySelector(".model-images__swiper");
    if (swiper && typeof Swiper !== 'undefined') {
      this.modelSwiper = new Swiper(swiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
    }
  }
}
customElements.define('landingpage-product', LandingpageProduct);

document.addEventListener("DOMContentLoaded", () => {
  // thumbnail-link-swiper
  const swiper = document.querySelector(".thumbnail-link-swiper");
  if (swiper && typeof Swiper !== 'undefined') {
    var thumbnailSwiper = new Swiper(swiper, {
      spaceBetween: 30,
      slidesPerView: "auto",
      slidesPerGroupAuto: true
    });
  }
});
